import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoggingService } from './logging.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ThankYouService {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService,
    private loggingService: LoggingService,
    
  ) { }

  triggerSummaryReport(userId: number): Observable<any> {
    this.loggingService.logDebug(`Triggering summary report for user ${userId}`);

    return this.httpClient.post(
      this.apiService.getUrl(`user-profile/${userId}/send-report`),
      {} 
    );
  }
}